__webpack_require__.p = "/mfe/appshell/latest/";